const componentSizes = ["default", "small", "large"];

export { componentSizes };
//# sourceMappingURL=size.mjs.map
